import { type FC, type ReactNode } from "react";

// The box under a Drafting section that reads his notes: its label, the
// field, its action, then the line on how his notes are used.
export const SectionNotes: FC<{
  label: string;
  field: ReactNode;
  action: ReactNode;
  line: string;
}> = ({ label, field, action, line }) => (
  <div className="space-y-2 px-3 pb-3">
    <p className="text-[10.5px] font-semibold tracking-[0.08em] text-slate-500 uppercase">
      {label}
    </p>
    {field}
    <div className="flex justify-end">{action}</div>
    <p className="text-[11.5px] text-slate-500">{line}</p>
  </div>
);
